interface SepsisWarningPanelProps {
  isDarkMode?: boolean;
  isChild?: boolean;
}

export function SepsisWarningPanel({
  isDarkMode = false,
  isChild = false,
}: SepsisWarningPanelProps) {
  const adultSigns = [
    "Slurred speech or confusion",
    "Extreme shivering or muscle pain",
    "Passing no urine (in a day)",
    "Severe breathlessness",
    "It feels like you're going to die",
    "Skin mottled or discoloured",
  ];

  const childrenSigns = [
    "Very fast breathing, breathlessness, grunting, or difficulty breathing",
    "Pale, blue, grey, or mottled skin; feels abnormally cold to touch",
    "Extremely lethargic, difficult to wake, confused, or unusually irritable",
    "Rash that does not fade when a glass is rolled over it",
    "No urine output or wet nappies for 12+ hours",
    "Very high fever or very low temperature",
    "Seizure or fit",
    "Weak, high-pitched, or persistent cry (especially in babies)",
    "Refusing to feed or repeated vomiting",
  ];

  const signs = isChild ? childrenSigns : adultSigns;
  const heading = isChild ? "How to spot sepsis in children" : "How to spot sepsis in adults";

  return (
    <div
      className={`mb-4 border rounded-lg p-4 ${
        isDarkMode
          ? "border-red-700 bg-red-950"
          : "border-red-300 bg-red-50"
      }`}
    >
      <h4
        className={`text-sm font-semibold mb-3 ${
          isDarkMode ? "text-red-200" : "text-red-900"
        }`}
      >
        {heading}
      </h4>
      <ol
        className={`text-xs space-y-1.5 list-decimal list-inside ${
          isDarkMode ? "text-red-100" : "text-red-800"
        }`}
      >
        {signs.map((sign, index) => (
          <li key={index}>{sign}</li>
        ))}
      </ol>
    </div>
  );
}
